import Class from './c-board';
import './c-board@';

export default Class;